namespace $ { export class $piterjs_screen extends $mol_view {

	/**
	 *  ```
	 *  place $piterjs_place
	 *  ```
	 **/
	@ $mol_mem
	place() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_place(  ) )
	}

	/**
	 *  ```
	 *  sub /
	 *  	<= Open
	 *  	<= Close
	 *  ```
	 **/
	sub() {
		return [this.Open() , this.Close()] as readonly any[]
	}

	/**
	 *  ```
	 *  Open $piterjs_screen_lines color <= color_open
	 *  ```
	 **/
	@ $mol_mem
	Open() {
		return (( obj )=>{
			obj.color = () => this.color_open()
			return obj
		})( new this.$.$piterjs_screen_lines(  ) )
	}

	/**
	 *  ```
	 *  color_open \#FFE515
	 *  ```
	 **/
	color_open() {
		return "#FFE515"
	}

	/**
	 *  ```
	 *  Close $piterjs_screen_lines color <= color_close
	 *  ```
	 **/
	@ $mol_mem
	Close() {
		return (( obj )=>{
			obj.color = () => this.color_close()
			return obj
		})( new this.$.$piterjs_screen_lines(  ) )
	}

	/**
	 *  ```
	 *  color_close \#FFE515
	 *  ```
	 **/
	color_close() {
		return "#FFE515"
	}

	/**
	 *  ```
	 *  content /$mol_view
	 *  ```
	 **/
	content() {
		return [] as readonly ( $mol_view )[]
	}

} }
